export class MetalConfigModel {

    /**
     * Math multiplier
     */
    math_multiplier: bigint = BigInt(1000000000);

    /**
     * Percentage divider
     */
    percentage_divider: bigint = BigInt(1000);

    /**
     * Admin percentage
     */
    admin_percentage: bigint = BigInt(20);

    /**
     * Cycle percentage
     */
    cycle_percentage: bigint = BigInt(30);

    /**
     * Winner percentage
     */
    winner_percentage: bigint = BigInt(950);

    /**
     * Max nuber of challenges
     */
    challenge_limit: bigint = BigInt(4);

    /**
     * Amount for first challenger
     */
    challenge_amount_1: bigint = BigInt(1000000000);

    /**
     * Amount for second challenger
     */
    challenge_amount_2: bigint = BigInt(3000000000);

    /**
     * Amount for third challenger
     */
    challenge_amount_3: bigint = BigInt(6000000000);

    /**
     * Amount for fourth challenger
     */
    challenge_amount_4: bigint = BigInt(10000000000);
}